import React from 'react'; // eslint-disable-line
import CloseX from '../svg/CloseX';
import i18n from '../../i18n';

const Dialog = (props) => {
    return (
        <div className={`dialog-overlay ${props.Visible ? 'dialog-show' : 'dialog-hide'}`}>
            <div className="dialog-content">
                {/* eslint-disable-next-line */}
                <a className="close-dialog" onClick={props.CloseDialog}>
                    <CloseX />
                </a>
                {props.children}
                {props.ShowButtons
                && (
                    <div className="btn-wrap">
                        <div className="btn-link-wrap action-cancel">
                            {/* eslint-disable-next-line */}
                            <a className="btn btn-link" onClick={props.CloseDialog}>
                                {i18n.t('cancel')}
                            </a>
                        </div>
                        <div className="btn-link-wrap action-save">
                            {/* eslint-disable-next-line */}
                            <a className="btn btn-link" onClick={props.ExecuteAction}>
                                {props.ActionName}
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dialog;
